import { useAppLanguage } from "hooks/useAppLanguage";
import { getAuthPortalCopy, type AuthPortal } from "lib/authPortalCopy";

export default function AuthPortalIntro({ portal }: { portal: AuthPortal }) {
  const language = useAppLanguage();
  const copy = getAuthPortalCopy(portal, language);

  return (
    <section className="mb-6 w-full text-center text-white">
      <div className="mx-auto inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/[0.08] px-4 py-2 text-xs font-semibold text-teal-200 backdrop-blur-sm">
        <span className="flex h-6 w-6 items-center justify-center rounded-lg bg-teal-400/20 text-teal-200">✦</span>
        {copy.portalLabel}
      </div>
      <h1 className="mt-4 text-2xl font-black tracking-tight sm:text-3xl">{copy.heroTitle}</h1>
      <p className="mx-auto mt-2 max-w-xl text-sm leading-7 text-white/65">{copy.heroSubtitle}</p>
      <div className="mt-4 grid gap-2 sm:grid-cols-3">
        {copy.heroBullets.map((item, index) => (
          <div key={item} className="rounded-2xl border border-white/15 bg-white/[0.08] px-3 py-3 text-start backdrop-blur-sm">
            <span className="text-lg font-black text-teal-200/70">0{index + 1}</span>
            <p className="mt-1 text-xs font-semibold leading-5 text-white/85">{item}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
